import ValidationErrorMessage from '@/components/error/validation-error-component';
import { getNestedErrorMessage } from '@/utils/utils';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import ControlledRedactor from './controlled-redactor-component';
import Styled from './rich-text-editor-style';

/**
 * @param {object}root0 -
 * @param {string} root0.name - The id of the div element to render the editor
 * @param {string} root0.label - The label of the editor
 * @param {boolean} root0.view - if read only
 * @param {boolean} root0.newVersion - if new version
 * @param {string} root0.marginBottom - the margin bottom of the editor
 * @param {Function} root0.onBlur - the function to call when the editor is blurred
 * @param {object} root0.rules - the rules of the editor
 * @returns {JSX.Element} - The editor input component
 */
const RichTextEditorInput = ({
  name,
  label,
  view,
  newVersion,
  marginBottom,
  onBlur,
  rules,
}) => {
  const { control, formState } = useFormContext();

  const { errors } = formState;

  const errorMessage = getNestedErrorMessage(name, errors);

  return (
    <Styled.MainContainer $marginBottom={marginBottom}>
      <Styled.Label>{label}</Styled.Label>
      <Controller
        defaultValue=""
        name={name}
        control={control}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <>
            <ControlledRedactor
              onChange={onChange}
              value={value}
              view={view}
              newVersion={newVersion}
              onBlur={onBlur}
            />
            <ValidationErrorMessage message={errorMessage} />
          </>
        )}
      />
    </Styled.MainContainer>
  );
};

RichTextEditorInput.defaultProps = {
  name: 'editor',
  newVersion: false,
  label: 'Description',
  marginBottom: 'none',
  onBlur: () => {},
  rules: {},
};

RichTextEditorInput.propTypes = {
  name: PropTypes.string,
  view: PropTypes.bool.isRequired,
  newVersion: PropTypes.bool,
  label: PropTypes.string,
  marginBottom: PropTypes.string,
  onBlur: PropTypes.func,
  rules: PropTypes.object,
};

export default RichTextEditorInput;
